import { render, staticRenderFns } from "./FrameworkCategory.vue?vue&type=template&id=81af0276"
import script from "./FrameworkCategory.vue?vue&type=script&lang=js"
export * from "./FrameworkCategory.vue?vue&type=script&lang=js"
import style0 from "./FrameworkCategory.vue?vue&type=style&index=0&id=81af0276&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports